export default __webpack_public_path__ + "static/media/ban.7938ac17.png";